"use client";

import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";

export default function NotificationSettingsPage() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold">Benachrichtigungen</h2>
        <p className="text-sm text-gray-500">
          Verwalte, wie du Benachrichtigungen erhältst
        </p>
      </div>

      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label>E-Mail-Benachrichtigungen</Label>
            <p className="text-sm text-gray-500">
              Erhalte Benachrichtigungen über deine Kontonutzung per E-Mail
            </p>
          </div>
          <Switch />
        </div>

        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label>Push-Benachrichtigungen</Label>
            <p className="text-sm text-gray-500">
              Erhalte Push-Benachrichtigungen in deinem Browser
            </p>
          </div>
          <Switch />
        </div>

        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label>Marketing-E-Mails</Label>
            <p className="text-sm text-gray-500">
              Erhalte E-Mails über neue Funktionen und Updates
            </p>
          </div>
          <Switch />
        </div>

        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label>Sicherheitswarnungen</Label>
            <p className="text-sm text-gray-500">
              Erhalte Warnungen bei verdächtigen Aktivitäten
            </p>
          </div>
          <Switch defaultChecked />
        </div>

        <Button>Änderungen speichern</Button>
      </div>
    </div>
  );
}
